import React from 'react';
import SearchableSelect from '../ui/SearchableSelect';
import { Activity, MasterData } from '../../types';

interface Props {
  activities: Activity[];
  masterData: MasterData;
  onChange: (activities: Activity[]) => void;
}

const AdditionalActivitiesForm: React.FC<Props> = ({ activities, masterData, onChange }) => {
  const addActivity = () => {
    onChange([...activities, { activity_id: -1, activity_name: '', calculated_adults: 0 }]);
  };

  const removeActivity = () => {
    if (activities.length > 0) {
      onChange(activities.slice(0, -1));
    }
  };

  const updateActivity = (index: number, updates: Partial<Activity>) => {
    const updated = [...activities];
    updated[index] = { ...updated[index], ...updates };
    console.log('updateActivity:', index, updates, updated);
    onChange(updated);
  };

  return (
    <div className="space-y-6">
      <div className="flex gap-4 mb-6">
        <button onClick={addActivity} className="btn-primary">
          ➕ Add Activity
        </button>
        <button onClick={removeActivity} className="btn-secondary" disabled={activities.length === 0}>
          ➖ Remove Activity
        </button>
      </div>

      {activities.length === 0 ? (
        <div className="text-center py-12 text-gray-500">
          No additional activities added yet. Click "Add Activity" to get started.
        </div>
      ) : (
        <div className="space-y-4">
          {activities.map((activity, index) => (
            <div key={index} className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 border border-gray-200 rounded-lg bg-gray-50">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Activity {index + 1}
                </label>
                <SearchableSelect
                  options={Object.entries(masterData.activities || {}).map(([name, id]) => ({ value: id, label: name }))}
                  value={activity.activity_id !== -1 ? activity.activity_id : ''}
                  onChange={(value) => {
                    const selectedOption = Object.entries(masterData.activities || {}).find(([name, id]) => id === value);
                    const id = value ? value as number : -1;
                    const name = selectedOption ? selectedOption[0] : '';
                    console.log('Selected activity:', id, name);
                    updateActivity(index, { activity_id: id, activity_name: name });
                  }}
                  placeholder="SELECT ACTIVITY"
                  className="text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Number of Pax
                </label>
                <input
                  type="number"
                  min="0"
                  value={activity.calculated_adults}
                  onChange={(e) => updateActivity(index, { calculated_adults: parseInt(e.target.value) || 0 })}
                  className="input-field"
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdditionalActivitiesForm;
